import type {
  DashboardSnapshot,
  FinanceReadinessPreviewItem,
} from "../../lib/dashboard";
import { FinanceReadinessPreview } from "../dashboard/overview/finance-readiness-preview";
import { RateWatchPreview } from "../dashboard/overview/rate-watch-preview";
import type { DataSourceOption } from "../dashboard/overview/data-source-chooser";
import { SectionLabel } from "../marketplace/OffersInbox";

export interface PrepareRowProps {
  items: readonly FinanceReadinessPreviewItem[];
  onOpenFinancials: () => void;
  onOpenRateWatch: () => void;
  onSelectVerificationSource: (
    source: DataSourceOption,
    item?: FinanceReadinessPreviewItem,
  ) => void;
  snapshot: DashboardSnapshot;
}

/**
 * Plan 435 M3 (mfh-prepare-row). `FinanceReadinessPreview` ·
 * `RateWatchPreview` two-column row — block 5 of every gate (design §4);
 * `OverviewScorePanel`-as-hero and `VerificationStatusStrip` retire from
 * Home entirely, their figures folded into `ReadinessChip`.
 */
export function PrepareRow({
  items,
  onOpenFinancials,
  onOpenRateWatch,
  onSelectVerificationSource,
  snapshot,
}: PrepareRowProps) {
  return (
    <section data-testid="home-prepare-row">
      <div className="mb-3">
        <SectionLabel label="Prepare" />
      </div>
      <div className="grid items-stretch gap-3 xl:grid-cols-2">
        <FinanceReadinessPreview
          items={items}
          onAddFinancialDetails={onOpenFinancials}
          onOpenFinancials={onOpenFinancials}
          onRefreshItem={() => onOpenFinancials()}
          onSelectVerificationSource={onSelectVerificationSource}
          onVerifyItem={() => undefined}
        />
        <RateWatchPreview onOpenRateWatch={onOpenRateWatch} snapshot={snapshot} />
      </div>
    </section>
  );
}
